import React from "react";
import "./MarketInsights.css";
import BackgroundImage from "../../assets/images/MarketInsightsImage.webp";
import { strings } from "../../translations/strings";
import ResponseLoader from "../../common/ResponseLoader";
import TextInput from "../../common/TextInput";
import Disclaimer from "../../common/Disclaimer";
import BackIcon from "../../common/BackIcon";
import FeedbackButtons from "../../common/FeedbackButtons";
import ResponseIcon from "../../assets/icons/MarketInsights.svg";
import AvatarIcon from "../../assets/images/Avatar.png";
import { transformText } from "../../helpers/functions";
import AskAgainButton from "../../common/AskAgainButton";

const MarketInsights = ({ data }) => {
  const {
    colors,
    goBack,
    isDarkMode,
    isError,
    isLoading,
    aIResponse,
    userInput,
    handleInputChange,
    onPressButton,
    onPressReset,
    isPressedFeedback,
    setIsPressedFeedback,
  } = data;
  return (
    <div className="market-insights-container">
      <img
        alt="Background"
        src={BackgroundImage}
        className="market-insights-background-image"
        draggable={false}
      />
      <div
        className="market-insights-hairline"
        style={{ backgroundColor: colors.borderColor }}
      />
      <div
        className="market-insights-content"
        style={{ backgroundColor: colors.componentBackground }}
      >
        <div className="market-insights-back-icon-container">
          <BackIcon colors={colors} onPress={goBack} isDarkMode={isDarkMode} />
        </div>
        {isLoading ? (
          <ResponseLoader colors={colors} />
        ) : (
          <>
            <span
              className="market-insights-title"
              style={{ color: colors.primaryText }}
            >
              {strings.market_insights_title}
            </span>
            <span
              className="market-insights-text"
              style={{ color: colors.secondaryText }}
            >
              {strings.market_insights_text}
            </span>
            <div className="market-insights-disclaimer-container">
              <Disclaimer colors={colors} />
            </div>
            {aIResponse ? (
              <>
                <div
                  className="market-insights-question-container"
                  style={{ borderColor: colors.borderColor }}
                >
                  <div className="market-insights-response-icon-and-text">
                    <img
                      alt="Avatar"
                      src={AvatarIcon}
                      draggable={false}
                      className="market-insights-response-icon"
                    />
                    <span
                      style={{ color: colors.primaryText }}
                      className="market-insights-response-text"
                    >
                      {userInput}
                    </span>
                  </div>
                </div>
                <div
                  className="market-insights-response-container"
                  style={{ borderColor: colors.borderColor }}
                >
                  <div className="market-insights-response-icon-and-text">
                    <img
                      alt="Response"
                      src={ResponseIcon}
                      draggable={false}
                      className="market-insights-response-icon"
                    />
                    <span
                      style={{
                        color: isError ? "#FF3E3E" : colors.primaryText,
                      }}
                      className="market-insights-response-text"
                    >
                      {transformText(aIResponse)}
                    </span>
                  </div>
                  {!isError && (
                    <FeedbackButtons
                      isDarkMode={isDarkMode}
                      colors={colors}
                      type={strings.market_insights_type}
                      isPressed={isPressedFeedback}
                      setIsPressed={setIsPressedFeedback}
                    />
                  )}
                </div>
                <AskAgainButton onPress={onPressReset} />
              </>
            ) : (
              <TextInput
                value={userInput}
                colors={colors}
                handleInputChange={handleInputChange}
                onPressButton={onPressButton}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default MarketInsights;
